import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as BSLogo } from '../../img/b_white.svg';

function SVG () {
  return <SvgIcon className="bsLogo"><BSLogo /></SvgIcon>;
}

export default SVG;
